<template>
	<div>
		<div class="p-6 grid grid-cols-2 md:grid-cols-3 gap-y-4 gap-x-6">
			<div
				class="col-span-3 border-bottom flex align-items-center justify-content-between"
			>
				{{ __(hubName) }}, {{ __(gradeName) }} {{ form.product.harvest }}
				<ui-tooltip
					class="ml-4 flex-shrink-0 text-black"
					:icon-stroke-width="1"
					icon-class="w-5 h-5"
					:text="__(form.quality.paper_fixed)"
				/>
			</div>

			<div>
				<label class="block font-medium text-gray-700" for="qty">{{
					__("Quantity in metric tons")
				}}</label>
				<ui-input-group
					class="mt-1"
					v-model="form.qty.mt"
					field="qty.mt"
					label
					suffix="t"
					:form="form"
					:required="true"
				></ui-input-group>
				<p class="mt-2 text-gray-500">
					{{ referenceLabel }} {{ form.qty.mt }}t
				</p>
			</div>

			<ui-validation-message :form="form" field="price.type" />
			<div class="col-span-3 mt-4 space-y-2">
				<paper-edit-price-select :form="form" />
			</div>

			<paper-edit-price :form="form" :activeFutures="activeFutures" />
		</div>

		<div class="p-6">
			<!-- monat -->
			<div class="flex space-x-6">
				<ui-radio-group
					name="form.date.type"
					v-model="form.date.type"
					radioValue="AT_HARVEST"
					:key="'AT_HARVEST-' + form.date.type"
					label="At Harvest"
				></ui-radio-group>
				<ui-radio-group
					v-model="form.date.type"
					name="form.date.type"
					radioValue="MONTH"
					:key="'MONTH-' + form.date.type"
					label="Month"
				></ui-radio-group>
				<ui-radio-group
					v-if="dateTypeOptions.includes('MULTIPLE')"
					name="form.date.type"
					v-model="form.date.type"
					radioValue="MULTIPLE"
					:key="'MULTIPLE-' + form.date.type"
					label="Consecutive Months without Storage Fee"
				></ui-radio-group>

				<ui-radio-group
					v-if="dateTypeOptions.includes('BASIS')"
					v-model="form.date.type"
					name="form.date.type"
					radioValue="BASIS"
					:key="'BASIS-' + form.date.type"
					label="Consecutive Months with Storage Fee"
				></ui-radio-group>
			</div>
			<div
				class="mt-6 grid grid-cols-2 md:grid-cols-3 gap-x-6 items-end"
				v-if="form.date.type == 'MONTH'"
			>
				<ui-month-input-group
					v-model="form.date.month_to"
					field="date.month_to"
					label="Month"
					:form="form"
					:required="true"
				></ui-month-input-group>
			</div>
			<div
				class="mt-6 grid grid-cols-2 md:grid-cols-3 gap-x-6 items-end"
				v-else-if="['MULTIPLE', 'BASIS'].includes(form.date.type)"
				:key="'MONTH_SELECT_' + form.date.type"
			>
				<ui-month-input-group
					v-model="form.date.month_from"
					field="date.month_from"
					label="Month From"
					:form="form"
					:required="true"
				></ui-month-input-group>

				<ui-month-input-group
					v-model="form.date.month_to"
					field="date.month_to"
					label="Month To"
					:form="form"
					:required="true"
				></ui-month-input-group>
			</div>
		</div>

		<div class="p-6 grid grid-cols-2 md:grid-cols-3 gap-x-6">
			<ui-select-group
				id="index-select-grade"
				v-model="form.extra.expiry_option"
				field="extra.expiry_option"
				type="select"
				label="Validity"
				:options="bidExpiryOptions"
				:form="form"
				:required="true"
			></ui-select-group>
		</div>
	</div>
</template>

<script>
let options = require("../../cropOptions");
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		trade: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			locationHubOptions: this.$cropOptions.getPaperHubs(),
		};
	},
	created() {
		this.form.quality.paper_fixed =
			this.currentHub.productGradeOptions[this.form.product.grade];
		/*
		// set reference if required
		if (!this.form.reference) {
			this.form.reference = {};
		}
		if (this.reference.type == "BID") {
			this.form.reference.bid_id = this.reference.id;
		} else if (this.reference.type == "OFFER") {
			if (this.reference.trade == "buy") {
				this.form.reference.offer_buy_id = this.reference.id;
			} else {
				this.form.reference.offer_sell_id = this.reference.id;
			}
		}*/
	},
	computed: {
		currentHub() {
			let filteredHub = options.standardHubs.filter(
				(h) => h.id == this.form.location.hub
			);

			return filteredHub[0] ? filteredHub[0] : null;
		},
		hubName() {
			return options.getLabel(this.form.location.hub, options.standardHubs);
		},
		gradeName() {
			return this.__(
				options.getLabel(this.form.product.grade, options.productGradeOptions)
			);
		},
		priceLabel() {
			return options.getLabel(this.form.price.type, [
				{ id: "FLAT", name: this.__("Fixed price") },
				{ id: "INDEXED", name: this.__("Premium-based indication") },
				{ id: "BASIS", name: this.__("Premium") },
			]);
		},
		productPriceFuture() {
			let future = this.activeFutures.filter(
				(f) => f.id == this.form.price.commodity_future_id
			);
			return future ? future[0] : null;
		},
		currentPriceEstimateIndexedPrice() {
			let basis = this.form.price.basis * 1,
				future = this.productPriceFuture;
			if (basis && future) {
				return basis + (future.euronext_price ?? future.last_price) * 1;
			} else {
				return null;
			}
		},
		referenceLabel() {
			if (this.trade == "SELL") {
				return this.__("Acc. demand");
			} else {
				return this.__("Acc. offer");
			}
		},
		submitButtonLabel() {
			if (this.trade == "SELL") {
				return this.__("Make a offer to the seller now!");
			} else {
				return this.__("Bid now!");
			}
		},
		bidExpiryOptions() {
			let d = new Date();
			return this.$cropOptions.bidExpiryOptions.filter((option) => {
				if (option.id == "TODAY_1830" && d.getHours() > 17) {
					return false;
				} else {
					return true;
				}
			});
		},
		dateTypeOptions() {
			return this.currentHub ? this.currentHub.dateTypeOptions : [];
		},
		priceGrid() {
			return {
				cols: "4",
				flat: {
					colSpan: [4],
				},
				indexed: {
					colSpan: [4, 4],
				},
			};
		},
	},
};
</script>
